<template>
	<div class="hd-mod-credits js-mod-credits">
		<div class="hd-mod-credit__content">
			<base-image-svg 
				colour="white"
				:source="require('!html-loader!@/plugins/pfizer/ui/assets/logos/svgs/pfizer-medical-affair-logo.svg')"
			/>
			<lyra-asset
				asset-key="app-copyright" 
			/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-credits {
		position: absolute;
		left: 250px;
		@include box(100%);
		width: calc(100% - 250px);
		@include flex-center();
		text-align: center;
		@include fade-out();

		&__content {
			@include fade-out();
		}

		:deep() svg {
			width: 200px;
			margin-bottom: 3px;
		}

		// Animations 
		&[data-state="animation-ready"] {
			opacity: 1;
			transition-delay: 0.25s;

			.hd-mod-credit__content {
				@include animation-frame-enter-downwards();
			}
		}

		// Responsive
		@include res-screen-small {
			left: 200px;
		}

		@include res-screen-portrait {
			@include center();
		}
	}
</style>